import React from 'react'
import { formatDate } from '../helper/formatDate';
import { wahoCard, whiteCard } from '../common/cssclasses';
import { formatDateTimeToString } from '../helper/formatDateTimeToString';

export default function CategoryCard({ translate, i, item }) {
    return <div
        className={wahoCard}
        key={i}
    >
        <div className={whiteCard}>
            {!!item.className && (
                <div className="horseCardTitle mb-1">
                    {item.className}
                </div>
            )}
            <div className='mb-form-group'>
                <div className="horseCardDescription fw-bold mb-1">
                    <i className='fa fa-calendar red' />
                    {translate("web.birthDate", "Birth Date") + " "}
                    {translate("web.from", "From") + " "}
                    {item.birthDateFrom && formatDateTimeToString(item.birthDateFrom) + " "}
                </div>


                <div className="horseCardDescription fw-bold mb-1">
                    <i className='fa fa-calendar red' />
                    {translate("web.birthDate", "Birth Date") + " "}
                    {translate("web.to", "to") + " "}
                    {item.birthDateTo && formatDateTimeToString(item.birthDateTo) + " "}
                </div>

                {!!item.maxNumPerClass && item.maxNumPerClass > 0 ?
                    <>
                        <div className="horseCardDescription fw-bold mb-1 " >
                            <span style={{ fontWeight: 'bold' }}>
                                <i className='fa-solid fa-chess-knight C89C66' /> {translate("web.horses", "Horses") + " "}
                            </span>
                            {(item.completedHorses) + " "}
                            {translate("web.of", "Of") + " " + item.maxNumPerClass + " "}
                            <span className='text-danger' style={{ fontWeight: 'bold' }}>
                                {translate("web.remaining", "Remaining") + " "}
                                {/* {item.remainingHorses} */}
                                {item.remainingHorses}
                            </span>
                        </div>

                    </>
                    :
                    <>
                        <div className="horseCardDescription fw-bold mb-1 " >
                            <span style={{ fontWeight: 'bold' }}>
                                <i className='fa-solid fa-chess-knight C89C66' />{translate("web.horsesConut", "عدد الخيول") + " "}
                                {item.completedHorses} {" "}
                            </span>
                            <span style={{ fontWeight: 'bold' }} >
                                {translate("web.noMaxNumber", "ولا يوجد حد أقصى") + " "}
                            </span>
                        </div>
                    </>
                }
            </div>

        </div>
    </div>;
}

